import type { SyncExternalBranchJobStatus } from '../enums/SyncExternalBranchJobStatus'

export class ExternalBranchJobStatusLogEntity {
  id?: string
  status?: SyncExternalBranchJobStatus
  dateTime?: string
}
